import React from "react";
import styles from "./Loading.module.css";
import logo from "../../star.png";

const Loading = () => {
  return (
    <div className={styles.Loading}>
      <div>
        <div>
          <span className={styles.Logo} aria-hidden="true" tabIndex="-1">
            <img src={logo} alt="Logo" />
          </span>
        </div>
        <p>Loading Priority Communities...</p>
      </div>
    </div>
  );
};

export default Loading;
